export default __webpack_public_path__ + "static/modal-login-image-e4d5d9e4b3e9ae75102c9855e9d070fc.svg";